/* ---------- 7. external links → new tab ---------- */

import { $$, EXTERNAL, setAttrs } from '../lib/dom';

export const externalLinks = () => $$('[data-external] a, a[data-external]').forEach((a) => setAttrs(a, EXTERNAL));
